





































import { computed, defineComponent } from '@vue/composition-api';
import { useFormat } from 'vivat';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';

const DeliveryOnMap = defineComponent({
  props: {
    delivery: {
      default() {
        return {
          id: -1,
          customerName: 'Idea Vivat',
          contactName: 'Firstname Lastname',
          orderNumber: 'UPA08XX',
          address: {
            address: 'XXXX/116',
            province: {
              id: -1,
              nameInThai: 'เมลเบิร์น',
              nameInEnglish: 'Melbourne',
            },
            district: {
              id: -1,
              nameInThai: 'ราชเทวี',
              nameInEnglish: 'Ratchatheveeee',
            },
            subdistrict: {
              id: -1,
              nameInThai: 'พญาไท',
              nameInEnglish: 'Phayathai',
            },
            zipcode: '32901',
            telephone: '09-XXXX-XXXX',
          },
          deliveryArea: 'EA1W0001',
          remarks: '',
          status: 'PENDING',
          urgentLevel: '',
          packages: [{
            name: '',
            width: '',
            length: '',
            height: '',
            count: '',
            weight: '',
            unitsPerCount: '',
          }],
          area: {
            name: 'IDV',
          },
        };
      },
    },
    lngLat: { default() { return { lat: 0, lng: 0 }; } },
  },
  setup(props: any) {
    const computedAddress = computed(() => `${props.delivery.address.address} ${props.delivery.address.province?.nameInThai} ${props.delivery.address.district?.nameInThai ? props.delivery.address.district?.nameInThai : ''} ${props.delivery.address.subdistrict?.nameInThai ? props.delivery.address.subdistrict?.nameInThai : ''}`);
    function formatToCurrency(number: string) {
      return useFormat.number(number).currency();
    }

    const { distanceTypeToChipClass, translateDistanceType } = useDeliveryAreaCode();

    return {
      computedAddress,
      formatToCurrency,
      distanceTypeToChipClass,
      translateDistanceType,
    };
  },
});

export default DeliveryOnMap;
